import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, googleProvider } from '../firebaseConfig'; // Adjust the import based on your structure
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, signInWithPopup } from 'firebase/auth';
import { createCredits } from '../components/Credits';  // or '../models/Credits' depending on your file structure

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function signup(email, password) {
    console.log('Signup process started for email:', email);
    try {
      console.log('Creating user with email and password...');
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      console.log('User created successfully. UID:', userCredential.user.uid);
      
      console.log('Initializing user credits...');
      try {
        await createCredits(userCredential.user.uid);
        console.log('User credits initialization completed');
      } catch (error) {
        console.error('Error initializing user credits:', error);
        // Consider what you want to do if credit initialization fails
        // You might want to delete the user or handle this error in some way
      }
      
      return userCredential;
    } catch (error) {
      console.error("Error during signup:", error);
      throw error;
    }
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  async function signupWithGoogle() {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      await createCredits(user.uid);
      return result;
    } catch (error) {
      console.error("Error during Google signup:", error);
      throw error;
    }
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    signup,
    login,
    logout,
    signupWithGoogle
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
